import { IDogBreed } from 'models/common.model'
import { adminApi } from 'nove8/api'
import { ProcessingKey } from 'nove8/constants/root-constants'
import { useZustandStore } from 'zustandGlobalStore'

export const fetchBreeds = async (locale: string): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.FETCH_BREEDS)

  const response = await adminApi.getBreeds(locale)

  if (response?.data && response?.success) {
    const responseBreeds: IDogBreed[] = response.data?.breeds
    useZustandStore.setState({
      breeds:
        responseBreeds?.filter((breed) => breed.key !== 'Test name') || [],
    })
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_BREEDS)
}
